<!--  -->
<template>
  <div class='EchartPractice'>
    <div :class="className"
         :id="id"
         :style="{width: '100%', height: '300px'}"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'echarts-pie',
  props: {
    className: {
      type: String,
      default: 'chartPiesolid',
    },
    id: {
      type: String,
      default: 'chartPiesolid',
    },
    titletop: {
      type: String,
    },
    itemsData: {
      type: Array,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.DrawBarChart()
  },
  watch: {
    itemsData: {
      handler(newName, oldName) {
        if (oldName) {
          this.DrawBarChart()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    DrawBarChart() {
      this.chart = echarts.init(document.getElementById(this.id))
      this.chart.showLoading({
        text: 'loading',
        color: '#0084cd',
        textColor: '#0084cd',
        maskColor: 'rgba(255, 255, 255, 0.2)',
        zlevel: 0,
      })

      let app = {}

      let option

      option = {
        title: {
          text: this.titletop,
          left: 'left',
          textStyle: {
            color: '#666',
            fontWeight: '100',
            fontSize: 13,
          },
        },
        icon: 'circle',
        legend: {
          bottom: '1%',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)',
        },

        series: [
          {
            type: 'pie',
            radius: [30, 120],
            center: ['50%', '50%'],
            top: '-50px',
            roseType: 'area',

            itemStyle: {
              borderRadius: 0,
              normal: {
                label: {
                  position: 'inner',
                  show: true,
                  formatter: '{c}',
                },
              },
            },
            label: {
              show: false,
            },
            data: this.itemsData,
          },
        ],
      }
      setTimeout(() => {
        // setOption前隐藏loading事件
        this.chart.hideLoading()
        this.chart.setOption(option, true)
      }, 1000)
      // this.chart.setOption(option)
    },
  },
}
</script>
<style lang="less" scoped>
.EchartPractice {
  padding-top: 10px;
}
</style>